import { DateHijri } from './date-hijri/date-hijri.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbDatepickerModule } from '../ng-bootstrap/datepicker/datepicker.module';
import { PaginatorModule } from './ngPrime/paginator/paginator';
import { HighLightPipe } from './pipes/searchWardsHighlighted.pipe';
import { FilterTextComponent } from './filter-text/filter-text.component';
import { StepperModule } from './stepper/stepper.module';
import { TabModule } from './tabs/tab.module';
import { ModalContainerModule } from './ui-component/modal-container/modal-container.module'
// pipes 
import { ActiveListPipe } from './pipes/active.list.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { SortByPropertyPipe } from './pipes/sort-by-property-pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ObjListFilterPipeModule } from '../blocks/pipes/obj-list-filter.pipe';
import { BreadcrumbModule } from './breadcrumb/breadcrumb.module';
import { VerticalList } from './vertical-list/vertical-list.component';
import { HttpGeneralService } from '../shared/http-general.service';
import { PateintBannerService } from './patientbanner/patient-banner.service';
import { PatientBannerModule } from './patientbanner/patient-banner.component';
import { MailComponent } from './mail/mail/mail.component';
//import { EmployeesPannerComponent } from './employee-panner-component/emloyee_panner.component';
import { FileUploadModule } from './file-upload/file-upload.component';
// import { CKEditorModule } from 'ng2-ckeditor';
import { PatientBloodTypeRhPopUpComponent } from './patient-bloodType-rh-popup/patient-bloodType-rh-popup.component';
import { SharedModule } from '../shared';
import { MatchValueDirective } from './match-value/match-value.directive';
import { EmrSelectizeComponent } from './emr-selectize/emr-selectize.component';
import { SelectizeService } from './selectize/selectize.service';
import { SanabelTooltipModule } from './sanabel-tooltip/sanabel-tooltip.module';
import { GenPatientServiceDetailModule } from './gen-patient-service-detail/gen-patient-service-detail.module';
import { UserSignatureComponent } from './user-signature/user-signature.component';
import { DrawOnImageModule } from './draw-on-image/draw-on-image.module';
import { ChartsComponent } from './charts';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { SimpleCallCenterPatientReservationComponent } from './simple-call-center-patient-reservation/simple-call-center-patient-reservation.component';
import { NamesComponent } from './names';

//import { PatientBloodTypeRhPopUpModule, PatientBloodTypeRhPopUpComponent } from './patient-bloodType-rh-popup/patient-bloodType-rh-popup.component';
// import { ChartsMod } from './charts/charts.component';

@NgModule({
    imports: [
        CommonModule,
        StepperModule,
        TabModule,
        BreadcrumbModule,
        PatientBannerModule,
        ModalContainerModule,
        FormsModule,
        NgbDatepickerModule,
        NgxChartsModule,
        NamesComponent,
        ReactiveFormsModule,
        ObjListFilterPipeModule,
        FileUploadModule,
        TranslateModule.forChild(),
        // CKEditorModule,
        SharedModule,
        SanabelTooltipModule,
        GenPatientServiceDetailModule
        //PatientBloodTypeRhPopUpModule
    ],
    declarations: [
        FilterTextComponent,
        // pipes 
        ActiveListPipe,
        HighLightPipe,
        SortByPropertyPipe,
        DateHijri,
        VerticalList,
        MatchValueDirective,
        EmrSelectizeComponent,
        UserSignatureComponent, ChartsComponent, SimpleCallCenterPatientReservationComponent
    ],
    exports: [
        PaginatorModule,
        StepperModule,
        TabModule,
        ChartsComponent,
        BreadcrumbModule,
        ModalContainerModule,
        DateHijri,
        FilterTextComponent,
        PatientBannerModule,
        ActiveListPipe,
        HighLightPipe,
        VerticalList,
        ObjListFilterPipeModule,
        MatchValueDirective,
        EmrSelectizeComponent,
        SanabelTooltipModule,
        UserSignatureComponent,
        DrawOnImageModule
    ],
    providers: [
        PateintBannerService,
        SelectizeService
    ]
})

export class BlocksModule { }
